import { get } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;

function fetchDelivery(data) {
  return get(`${url}`, data);
}

export default {
  fetchDebtByTourId: fetchDelivery,
};
